module.exports = __webpack_public_path__ + "static/media/99100c0d.jpg";